define('lq/dynamicContentImage',[
    'lq/imageSize',
    'lq'
], function(imageSize, lq) {

    var imageTypes = [
        'png',
        'jpg',
        'jpeg',
        'gif',
        'tiff',
        'bmp',
        'pdf'
    ];

    var isImageExtension = function(extension) {
        return imageTypes.indexOf(extension) !== -1;
    };

    var isSvg = function(extension) {
        return extension === 'svg';
    };

    var extractExtension = function(imageName) {
        return imageName.substr(imageName.lastIndexOf('.') + 1, imageName.length - imageName.lastIndexOf('.')).toLowerCase();
    };

    var isFullUrl = function (imageName) {
        return imageName.indexOf('http://') === 0 ||
            imageName.indexOf('https://') === 0 ||
            imageName.indexOf('//') === 0;
    };

    var getPath = function (options) {
        if (isFullUrl(options.imageName))
            return options.imageName;

        var imageName = options.imageName.replace(/\\/g, '/');
        var useThumbnail = options.useThumbnail;
        var resizeOption = options.resizeOption;
        var thumbnailFileType = options.thumbnailFileType;
        var size = options.size;
        var extension = extractExtension(imageName);

        if (isSvg(extension))
            return lq.getTenantUrl('DynamicContent/File/' + imageName);

        if (!isImageExtension(extension) || (extension === 'pdf' && !useThumbnail))
            return lq.getTenantUrl('DynamicContent/Icon/' + imageName);

        if (useThumbnail) {
            var requiredSize = imageSize.forElement(size);

            return lq.getTenantUrl('DynamicContent/Thumbnail/' + imageName
                + '?width=' + requiredSize.x
                + '&height=' + requiredSize.y
                + "&filetype=" + thumbnailFileType
                + "&isMaxSize=" + (resizeOption === 'fillKeepRatio' ? 'false' : 'true'));
        }

        return lq.getTenantUrl('DynamicContent/File/' + imageName);
    };

    return {
        getPath: getPath
    };
});
